const LOCAL_ASSET = '/assets/img';
const S3_BASE = (process.env.REACT_APP_S3_PATH || '').replace(/\/+$/, '');

/** Prefer S3 when REACT_APP_S3_PATH is set (staging/prod) so large MP4s are not served from Amplify. */
function assetUrl(relativePath) {
  const clean = String(relativePath || '').replace(/^\/+/, '');
  if (S3_BASE) return `${S3_BASE}/assets/img/${clean}`;
  return `${LOCAL_ASSET}/${clean}`;
}

function videoUrl(filename) {
  return assetUrl(filename);
}

const ASSET = LOCAL_ASSET;

/** Static puzzle config mirrored from PHP game.php / game2–4.php */
export const ROUNDS = {
  1: {
    id: 1,
    title: 'Round 1 - Way Out Puzzle',
    titleColor: '#fff',
    titleBg: '#6a0409',
    buttonBg: '#6a0409',
    buttonColor: '#fff',
    numberBg: '#6a0409',
    numberColor: '#fff',
    frameBg: 'transparent',
    backTo: '/rules',
    nextRound: 2,
    bgType: 'image',
    bgImage: `${ASSET}/round1/r1-BG.png`,
    blockImage: `${ASSET}/round1/BlockImage.png`,
    video: null,
    resetTimer: true,
    checkCompleted: false,
    puzzles: [
      {
        image: `${ASSET}/round1/Picture11.png`,
        answerGif: `${ASSET}/popup/R1C.gif`,
        answer: 'C',
      },
      {
        image: `${ASSET}/round1/Picture12.png`,
        answerGif: `${ASSET}/popup/R1A.gif`,
        answer: 'A',
      },
      {
        image: `${ASSET}/round1/Picture3.png`,
        answerGif: `${ASSET}/popup/R1D.gif`,
        answer: 'D',
      },
      {
        image: `${ASSET}/round1/Picture4.png`,
        answerGif: `${ASSET}/popup/R1D.gif`,
        answer: 'D',
      },
    ],
  },
  2: {
    id: 2,
    title: 'Round 2 - Mind Teasers',
    titleColor: '#fff',
    titleBg: '#7A00FF',
    buttonBg: '#7A00FF',
    buttonColor: '#fff',
    numberBg: '#7A00FF',
    numberColor: '#fff',
    frameBg: '#FFF600',
    backTo: '/rounds/1',
    nextRound: 3,
    bgType: 'video',
    video: videoUrl('BG3.mp4'),
    resetTimer: false,
    checkCompleted: false,
    puzzles: [
      {
        image: `${ASSET}/round2/Picture1.jpg`,
        answerGif: `${ASSET}/popup/R45.gif`,
        answer: '5',
      },
      {
        image: `${ASSET}/round2/Picture2.jpg`,
        answerGif: `${ASSET}/popup/R2B.gif`,
        answer: 'B',
      },
      {
        image: `${ASSET}/round2/Picture3.jpg`,
        answerGif: `${ASSET}/popup/R2A.gif`,
        answer: 'A',
      },
      {
        image: `${ASSET}/round2/Picture4.jpg`,
        answerGif: `${ASSET}/popup/R2C.gif`,
        answer: 'C',
      },
    ],
  },
  3: {
    id: 3,
    title: 'Round 3 - Rebus Puzzle',
    titleColor: '#000',
    titleBg: '#FFF600',
    buttonBg: '#FFF600',
    buttonColor: '#000',
    numberBg: '#FFF600',
    numberColor: '#000',
    frameBg: '#FFF600',
    backTo: '/rounds/2',
    nextRound: 4,
    bgType: 'video',
    video: videoUrl('BG4.mp4'),
    resetTimer: false,
    checkCompleted: true,
    puzzles: [
      {
        image: `${ASSET}/round3/Picture1.png`,
        answerGif: `${ASSET}/popup/R3_Sitting.gif`,
        answer: '',
      },
      {
        image: `${ASSET}/round3/Picture2.png`,
        answerGif: `${ASSET}/popup/R3_Understand.gif`,
        answer: '',
      },
      {
        image: `${ASSET}/round3/Picture3.png`,
        answerGif: `${ASSET}/popup/R3.gif`,
        answer: '',
      },
      {
        image: `${ASSET}/round3/Picture4.png`,
        answerGif: `${ASSET}/popup/R3_walking.gif`,
        answer: '',
      },
    ],
  },
  4: {
    id: 4,
    title: 'Round 4 - Illusions',
    titleColor: '#000',
    titleBg: '#FFF600',
    buttonBg: '#FFF600',
    buttonColor: '#000',
    numberBg: '#FFF600',
    numberColor: '#000',
    frameBg: '#FFF600',
    backTo: '/rounds/3',
    nextRound: null,
    bgType: 'video',
    video: videoUrl('BG4.mp4'),
    resetTimer: false,
    checkCompleted: true,
    isFinal: true,
    puzzles: [
      {
        image: `${ASSET}/round4/Picture1.jpg`,
        answerGif: `${ASSET}/popup/R4_LionMonkey.gif`,
        answer: 'Lion & Monkey',
        question: 'Name the animals you see here',
      },
      {
        image: `${ASSET}/round4/Picture2.jpg`,
        answerGif: `${ASSET}/popup/R46.gif`,
        answer: '4',
        question: 'How many human faces?',
      },
      {
        image: `${ASSET}/round4/Picture3.jpg`,
        answerGif: `${ASSET}/popup/R4_Notbook.gif`,
        answer: 'Not everything is in a book',
        question: "What's the message",
      },
      {
        image: `${ASSET}/round4/Picture4.png`,
        answerGif: `${ASSET}/popup/R45.gif`,
        answer: '5',
        question: "How many 'Y'",
      },
    ],
  },
};

export const RULES_TEXT = [
  'Decode the cryptic codes to identify the items in your home / workplace.',
  'Collect all items and show your facilitator on camera.',
];

export const INTRO_GIF = `${ASSET}/Brain_Teaser_Intro.gif`;
export const RULES_LOGO = `${ASSET}/brain-teasers.gif`;
export const RULES_VIDEO = videoUrl('BG2.mp4');
export const AWESOME_GIF = `${ASSET}/Awesome.gif`;
export const TIMER_STORAGE_KEY = 'bt_gettime';
export { assetUrl, videoUrl };
